/* DSL Browse-abandonment — log when user views product but leaves without ATC */
(function(){
  if (location.pathname.indexOf("/products/") !== 0) return;
  var added = false;
  document.addEventListener("dsl:cart:add", function(){ added = true; });
  addEventListener("pagehide", function(){
    if (!added && window.DSL_AB) {
      window.DSL_AB.track("browse_abandoned", {handle: location.pathname.split("/")[2]});
    }
  }, {once: true});
})();